import { Box } from "@/storybook-components";
import { BazaarComponent } from "./index";

/**
 * Base bazaar card/wrapper component
 * used as a default wrapper around the element
 */
const Card = ({ children, ...rest }: BazaarComponent): JSX.Element => {
  return (
    <Box
      borderWidth="1px"
      borderStyle="solid"
      borderRadius="sm"
      overflow="hidden"
      className="ehq-card"
      borderColor="gray.200"
      {...rest}
    >
      {children}
    </Box>
  );
};

export default Card;
